import { NGXLogger } from 'ngx-logger';

export function safeJSONParse<T>(jsonString: string | undefined, logger: NGXLogger): T | null {
    if (!jsonString) {
        return null;
    }
    try {
        return JSON.parse(jsonString) as T;
    } catch (error) {
        logger.error(`Failed to parse JSON: ${error}`);
        return null;
    }
}

export function parseMaybeJsonValue<T>(value: unknown, logger: NGXLogger): T | null {
    if (value == null) {
        return null;
    }

    if (typeof value === 'string') {
        return safeJSONParse<T>(value, logger);
    }

    return value as T;
}

export function parseMaybeJsonList<T>(value: unknown, logger: NGXLogger): T[] {
    if (!Array.isArray(value)) {
        return [];
    }

    return value
        .map(item => parseMaybeJsonValue<T>(item, logger))
        .filter((item): item is T => item != null);
}
